import React, { useMemo } from 'react';
import { PlanType, PlanTypeColor } from '../../util';
import dayjs from 'dayjs';
import './index.css';

export interface TimeRange {
  start: string; // "HH:mm"
  end: string; // "HH:mm"
  type: PlanType;
}

interface TwoDayTimelineProps {
  ranges: TimeRange[];
  baseTime: string;
}

const TwoDayTimeline: React.FC<TwoDayTimelineProps> = ({ ranges, baseTime }) => {
  const minutesInTwoDays = 48 * 60;

  const getMinutesFromMidnight = (time: string) => {
    const [h, m] = dayjs(time).format('HH:mm').split(':').map(Number);
    return h * 60 + m;
  };

  const timelineItems = ranges.map((range, index) => {
    let startMinutes = getMinutesFromMidnight(range.start);
    let endMinutes = getMinutesFromMidnight(range.end);

    if (dayjs(range.start).isAfter(baseTime, 'day')) {
      // 跨日处理
      startMinutes += 24 * 60;
    }
    if (dayjs(range.end).isAfter(baseTime, 'day')) {
      // 跨日处理
      endMinutes += 24 * 60;
    }

    const duration = endMinutes - startMinutes;
    const leftPercent = (startMinutes / minutesInTwoDays) * 100;
    const widthPercent = (duration / minutesInTwoDays) * 100;

    return (
      <div
        key={index}
        className="timeline-block"
        style={{
          left: `${leftPercent}%`,
          width: `${widthPercent}%`,
          backgroundColor: PlanTypeColor[range.type] || '#1677FF',
        }}
      />
    );
  });

  return (
    <div className="timeline-container horizontal">
      <div className="timeline-content horizontal">{timelineItems}</div>
      <div className="midline" />
      <div className="timeAxisContainer" style={{ left: '-5%' }}>
        00:00
      </div>
      <div className="timeAxisContainer" style={{ left: '42%' }}>
        次日00:00
      </div>
      <div className="timeAxisContainer" style={{ right: '-5%' }}>
        00:00
      </div>
    </div>
  );
};

export default TwoDayTimeline;
